module.exports = __webpack_public_path__ + "img/tianjin.71d660fc.jpg";